/**
 * VistoeraTASK-00582 — legacy `/canvas-resume` alias from TASK-00581.
 *
 * Always replace onto `/home`, which is the fullscreen Canvas entry (no
 * Workbench flash) and owns last-opened → Home Canvas resolution.
 */
import { Navigate, useParams } from 'react-router-dom'

export default function CanvasAccountResumePage() {
  const { workspaceId = '' } = useParams()
  return <Navigate to={`/workspace/${workspaceId}/home`} replace />
}
